var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.56 2.1c0 1.16-.88 2.1-2.29 2.1h-.02C.88 4.2 0 3.25 0 2.1.01.9.91 0 2.3 0c1.38 0 2.23.9 2.26 2.1zM.25 18h4.03V5.85H.25V18zM14.19 5.57a4.01 4.01 0 00-3.64 2v.04h-.02l.02-.04V5.85H6.52C6.57 7 6.52 18 6.52 18h4.03v-6.78c0-.37.03-.73.14-.98.3-.72.95-1.48 2.07-1.48 1.46 0 2.05 1.11 2.05 2.74V18h4.03v-6.96c0-3.72-2-5.46-4.65-5.46z",
    fill: "#778CA3"
  })));
}
export default SvgLinkedinFooter;